// ============================================================
// Dar Hasna Collection — data
// Business model (Feb 2026 — pivot) :
//   • Villa Hasna uniquement — maison d'hôtes 3 suites + privatisation villa entière (6 pax)
//   • Villa Ismaël retirée du catalogue
// ============================================================

const HASNA_DIR = "/villas/hasna";

// --- Villa Hasna (Beldi Chic, 36 photos) ---
const HASNA_FILES = [
  "IMG_0773.jpeg", // HERO — piscine + jardin + palmiers
  "IMG_3471.jpeg", // façade terracotta
  "IMG_0761.jpeg",
  "IMG_0763.jpeg",
  "IMG_0764.jpeg",
  "IMG_0765.jpeg",
  "IMG_0766.jpeg",
  "IMG_0768.jpeg",
  "IMG_0771.jpeg",
  "IMG_0772.jpeg",
  "IMG_0774.jpeg",
  "IMG_0775.jpeg",
  "IMG_0777.jpeg",
  "IMG_0778.jpeg",
  "IMG_0779.jpeg",
  "IMG_0780.jpeg",
  "IMG_3465.jpeg",
  "IMG_3466.jpeg",
  "IMG_3467.jpeg",
  "IMG_3468.jpeg",
  "IMG_3470.jpeg",
  "IMG_3472.jpeg",
  "IMG_3473.jpeg",
  "IMG_3474.jpeg",
  "IMG_3475.jpeg",
  "IMG_3476.jpeg",
  "IMG_3477.jpeg",
  "IMG_3478.jpeg",
  "IMG_3479.jpeg",
  "IMG_3481.jpeg",
  "IMG_3482.jpeg",
  "IMG_3483.jpeg",
  "IMG_3484.jpeg",
  "IMG_3485.jpeg",
  "IMG_3487.jpeg",
  "IMG_3488.jpeg",
];

const hasnaGallery = HASNA_FILES.map((f) => `${HASNA_DIR}/${f}`);

export const HERO_POOL = hasnaGallery[0];
export const HERO_FACADE = hasnaGallery[1]; // Legacy export, pointe désormais sur la façade Hasna
export const POOL_FULL = `${HASNA_DIR}/IMG_0771.jpeg`;

export const SERVICE_IMAGES = {
  chef: "https://images.pexels.com/photos/4502972/pexels-photo-4502972.jpeg?auto=compress&w=1200",
  spa: "https://images.pexels.com/photos/16151060/pexels-photo-16151060.jpeg?auto=compress&w=1200",
  pool: POOL_FULL,
  transport: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1600&q=80",
};

export const villas = {
  hasna: {
    slug: "hasna",
    name: "Villa Hasna",
    tagKey: "hasnaTag",
    styleKey: "hasnaStyle",
    hero: hasnaGallery[0],
    gallery: hasnaGallery,
    mode: "guesthouse",
    capacity: 6,
    suitesCount: 3,
  },
};

// ------------------------------------------------------------
// PRICING (MAD/nuit) — source Airbnb Feb 2026
// ------------------------------------------------------------

export const HASNA_SUITES = [
  {
    key: "twin",
    nameKey: "hasnaSuiteTwinName",
    descKey: "hasnaSuiteTwinDesc",
    priceLow: 947,
    priceHigh: 947,
    photos: [hasnaGallery[10], hasnaGallery[15], hasnaGallery[20]],
  },
  {
    key: "confort",
    nameKey: "hasnaSuiteConfortName",
    descKey: "hasnaSuiteConfortDesc",
    priceLow: 1598,
    priceHigh: 1776,
    photos: [hasnaGallery[3], hasnaGallery[12], hasnaGallery[24]],
  },
  {
    key: "master",
    nameKey: "hasnaSuiteMasterName",
    descKey: "hasnaSuiteMasterDesc",
    priceLow: 1598,
    priceHigh: 1776,
    photos: [hasnaGallery[0], hasnaGallery[8], hasnaGallery[30]],
  },
];

export const HASNA_ENTIRE = {
  priceLow: 5400,
  priceHigh: 6000,
};

// Formules Séjour Famille — Villa Hasna
export const FAMILY_PACKAGES = [
  { key: "essentielle", price: 3626, accent: false, extraKeys: ["breakfast", "shuttle", "nannyEvening1"] },
  { key: "confort", price: 5230, accent: true, extraKeys: ["halfBoard", "dailyTransport", "nannyDayEvening", "massageParents"] },
  { key: "premium", price: 5580, accent: false, extraKeys: ["chauffeur", "nanny8h2evenings", "massageParents"] },
];

// Estimate per villa (EUR), used by BookingForm
export const PRICING = {
  hasna: { low: 496, high: 552 },
};

export const OWNER = {
  whatsapp: "+212 7 18 11 54 19",
  waLink: "https://wa.me/212718115419",
  phone: "+212 7 18 11 54 19",
  email: "darhasnacollection@gmail.com",
  address: "Sidi Yahya La Palmeraie · Marrakech 40 000",
  instagram: "https://instagram.com/darhasnacollection",
  facebook: "https://facebook.com/darhasnacollection",
  tiktok: "https://tiktok.com/@darhasnacollection",
  snapchat: "https://snapchat.com/add/darhasnacollection",
};

export const SERVICES = {
  pool: [
    { label: "Chauffage piscine", price: "80 € / jour" },
    { label: "Privatisation journée (11h-18h, 10 pers.)", price: "350 €" },
    { label: "Personne supplémentaire", price: "+15 € / pers." },
    { label: "Brunch en option", price: "20 € / pers." },
  ],
  dining: [
    { label: "Petit-déjeuner", price: "13 € / pers." },
    { label: "Chef privé (entrée, plat, dessert)", price: "30 € / pers. / repas" },
    { label: "Demi-pension", price: "40 € / pers. / jour" },
    { label: "Pension complète", price: "65 € / pers. / jour" },
    { label: "Goûter en supplément", price: "7 € / pers." },
  ],
  transport: [
    { label: "Navette aéroport", price: "45 €" },
    { label: "Trajet villa – centre-ville (4 pers.)", price: "35 €" },
    { label: "Trajet villa – centre-ville (6 pers.)", price: "50 €" },
    { label: "Trajet de nuit", price: "65 €" },
    { label: "Chauffeur privé à la journée", price: "180 €" },
    { label: "Location voiture", price: "dès 70 € / jour" },
    { label: "Location scooter", price: "dès 45 € / jour" },
  ],
  wellness: [
    { label: "Massage 1h", price: "400 MAD" },
    { label: "Massage 2h", price: "700 MAD" },
    { label: "Hijama", price: "dès 300 MAD" },
    { label: "Coiffeur / Barbier", price: "dès 250 MAD" },
  ],
  nanny: [
    { label: "Nounou (8h-20h)", price: "10 € / heure" },
    { label: "Nounou (20h-8h)", price: "15 € / heure" },
    { label: "Jusqu'à 2 enfants — dédiée obligatoire < 3 ans", price: "" },
  ],
  housekeeping: [
    { label: "Femme de ménage (9h-18h)", price: "50 € / jour" },
    { label: "Départ 12h-15h", price: "demi-nuit" },
    { label: "Départ après 15h", price: "nuit complète" },
  ],
  extras: [
    { label: "Adulte supplémentaire", price: "50 € / nuit" },
    { label: "Enfant supplémentaire", price: "30 € / nuit" },
    { label: "Bébé < 2 ans", price: "Gratuit" },
    { label: "Visiteur extérieur (autorisation requise)", price: "30 € / pers. / jour" },
  ],
};

export const MENUS = {
  breakfast: {
    beldi: ["Msemen", "Baghrir", "Viennoiserie", "Œuf brouillé", "Pain marocain", "Olive noire"],
    occidentale: ["Mini pancakes", "Brioche perdue", "Viennoiserie", "Composition fruitée", "Baguette française"],
    healthy: ["Avocado toast", "Granola bowl aux fruits rouges", "Œuf brouillé", "Pain aux céréales"],
  },
  entrees: [
    "Salade marocaine revisitée & zaalouk",
    "Burrata et tomate rôtie",
    "Tenders maison croustillants",
    "Cannelloni de courgette au fromage frais",
    "Assortiment de briouates (fromage/poulet)",
    "Sushi & Maki thon cuit / avocat / cheese",
  ],
  plats: [
    "Suprême de poulet farci & pommes grenaille",
    "Riz sauté au bœuf loklak",
    "Tajine de veau aux petits légumes",
    "Lasagne bolognaise",
    "Poulet krousty",
    "Pureli köfte",
    "Lasagne au thon et légumes grillés",
    "Nouilles sautées au poulet laqué",
  ],
  desserts: [
    "Banoffee pie",
    "Franoffee pie",
    "Composition fruitée",
    "Dôme au chocolat blanc et fruits rouges",
  ],
};
